import actions from "./actions";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: {
    projects: [],
    selectedProjectId: "",
    selectedProjectEmails: [],
  },
  mutations,
  actions,
};
